export const GET_CHATS = {
    REQUEST:"GET_CHATS_REQUEST",
    SUCCESS:"GET_CHATS_SUCCESS",
    FAIL:"GET_CHATS_FAIL",
}

export const GET_CHAT_MESSAGES = {
    REQUEST:"GET_CHAT_MESSAGES_REQUEST",
    SUCCESS:"GET_CHAT_MESSAGES_SUCCESS",
    FAIL:"GET_CHAT_MESSAGES_FAIL",
}

export const SEND_MESSAGE = {
    REQUEST:"SEND_MESSAGE_REQUEST",
    SUCCESS:"SEND_MESSAGE_SUCCESS",
    FAIL:"SEND_MESSAGE_FAIL",
}

export const CREATE_CHAT = {
    REQUEST:"CREATE_CHAT_REQUEST",
    SUCCESS:"CREATE_CHAT_SUCCESS",
    FAIL:"CREATE_CHAT_FAIL",
}

export const RESET_MESSAGES = {
    REQUEST:"RESET_MESSAGES"
}

export const ADD_MESSAGE = {
    REQUEST:"ADD_MESSAGE"
}
